module.exports = __webpack_public_path__ + "img/upload_file.80c25992.svg";